import { AppRouteProps } from "@harea/component";
import React from "react";
import { ProjectDayOffViewsSummaryRoutes } from "./views/summary/ProjectDayOffViewsSummaryRoutes";
import { ProjectDayOffViewsDemandRoutes } from "./views/demand/ProjectDayOffViewsDemandRoutes";
import { ProjectDayOffViewsCalendarRoutes } from "./views/calendar/ProjectDayOffViewsCalendarRoutes";
import { ProjectDayOffMissingRoutes } from "./views/missing/ProjectDayOffMissingRoutes";
import { ProjectCalendarCardDetailsRoutes } from "views/calendar/views/details/ProjectCalendarCardDetailsRoutes";
import ProjectDayOffViewsDemandContainer from "./views/demand/container/ProjectDayOffViewsDemandContainer";
import { ProjectDayOffCreateRoutes } from "./views/demand/views/create/ProjectDayOffCreateRoutes";
import { DayoffMissingDetailsRoutes } from "./views/missing/views/details/DayoffMissingDetailsRoutes";
import ProjectDayOffMissingContainer from "./views/missing/container/ProjectDayOffMissingContainer";
import { ProjectAppointmentCreateMissingRoutes } from "views/create/views/missing/ProjectAppointmentCreateMissingRoutes";
import { LateCreateRoutes, LateDetailsRoute } from "./views/late/views/create/LateCreateRoutes";

const ProjectDayOffLateContainer = React.lazy(
    () => import("./views/late/container/ProjectDayOffLateContainer")
);

export const ProjectDayOffRoutes: Array<AppRouteProps> = [
    {
        path: "timeoffs/demands",
        title: "BSMRH.Project.DayOff.Management.Vacation.Demands.Label",
        element: <ProjectDayOffViewsDemandContainer />,
        children: [
            ...ProjectCalendarCardDetailsRoutes,
            ...ProjectDayOffCreateRoutes
        ],
    },
    {
        path: "timeoffs/missings",
        title: "BSMRH.Project.DayOff.Management.Vacation.Abscence.Label",
        element: <ProjectDayOffMissingContainer />,
        children: [
            ...DayoffMissingDetailsRoutes,
            ...ProjectAppointmentCreateMissingRoutes
        ]
    },
    {
        ...ProjectDayOffViewsSummaryRoutes[0],
        path: "timeoffs/summary",
    },
    {
        path: "timeoffs/lates",
        title: "std_late",
        element: <ProjectDayOffLateContainer />,
        children: [
            ...LateCreateRoutes,
            LateDetailsRoute,
        ],
    },
];
